<template>
    <div class="min-h-screen bg-white font-sans selection:bg-blue-100">
        <main>
            <!-- Hero Section -->
            <section class="relative min-h-screen flex items-center justify-center pt-20 px-4 overflow-hidden">
                <!-- Background Image -->
                <div class="absolute inset-0 z-0">
                    <img src="../../assets/img/scenry.jpg" alt="Artistic Landscape Background"
                        class="w-full h-full object-cover opacity-90" />
                    <div class="absolute inset-0 bg-white/30 mix-blend-overlay"></div>
                </div>

                <div class="container mx-auto relative z-10 text-center">
                    <div
                        class="inline-block backdrop-blur-md bg-white/70 p-8 md:p-16 rounded-sm shadow-sm border border-white/50 max-w-4xl mx-auto transition-all duration-700 ease-out">
                        <span
                            class="inline-block mb-4 text-xs md:text-sm font-medium tracking-widest uppercase text-gray-600">
                            Fine Art & Illustration
                        </span>

                        <!-- <h1
                            class="text-5xl md:text-7xl lg:text-9xl font-serif font-normal text-gray-900 tracking-tight mb-6 drop-shadow-sm">
                            ArtPulse
                            <span class="block text-2xl md:text-4xl lg:text-5xl mt-2 italic text-gray-700 font-light">
                                by Shruti
                            </span>
                        </h1> -->
                    <!-- Add logo here with large size-->
                    <div class="flex items-center justify-center mb-6">
                        <img src="https://assets-allwebsites.s3.ap-south-1.amazonaws.com/artpulse/logoartpulse.jpeg" alt="ArtPulse Logo" class="w-100 h-64 object-contain" />
                    </div>  

                        <p
                            class="max-w-xl mx-auto text-base md:text-lg text-gray-700 leading-relaxed mb-10 font-medium">
                            Exploring the boundaries of imagination through colors and strokes. A journey into the
                            soulful world of artistic expression.
                        </p>

                        <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
                            <RouterLink to="/gallery">
                                <button
                                    class="rounded-none px-8 py-6 text-sm tracking-widest uppercase bg-blue-600 text-white hover:bg-blue-700 w-full sm:w-auto">
                                    View Gallery
                                </button>
                            </RouterLink>

                            <a href="https://www.youtube.com/@artpulse_by_shruti" target="_blank">
                                <button
                                    class="rounded-none px-8 py-6 text-sm tracking-widest uppercase border border-blue-600 text-blue-600 hover:bg-gray-100 w-full sm:w-auto border-black">
                                    Watch on YouTube
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Scroll Indicator -->
                <div
                    class="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-gray-900 drop-shadow-md">
                    <span class="text-[10px] uppercase tracking-widest font-medium">
                        Scroll to Explore
                    </span>
                    <div class="w-[1px] h-12 bg-gray-900"></div>
                </div>
            </section>

            <!-- Featured Works -->
            <section class="py-24 bg-gray-100">
                <div class="container mx-auto px-4">
                    <div class="flex flex-col md:flex-row items-end justify-between mb-12 gap-4">
                        <div>
                            <h2 class="text-3xl md:text-4xl font-serif mb-2">Featured Works</h2>
                            <p class="text-gray-600">Recent creations from the studio</p>
                        </div>

                        <RouterLink to="/gallery">
                            <button class="text-blue-600 p-0 h-auto group text-lg font-serif flex items-center gap-1">
                                View All Works
                                <svg class="w-4 h-4 transition-transform group-hover:translate-x-1" fill="currentColor"
                                    viewBox="0 0 20 20">
                                    <path
                                        d="M12.293 3.293a1 1 0 011.414 1.414L10.414 8H17a1 1 0 110 2h-6.586l3.293 3.293a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414l5-5z" />
                                </svg>
                            </button>
                        </RouterLink>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <RouterLink v-for="(item, index) in filteredArtworks" :key="index" to="/gallery" class="block">
                            <div :class="['md:mt-12 group cursor-pointer']">
                                <div
                                    class="aspect-[4/5] overflow-hidden relative mb-4 border border-border/50 bg-white p-2 shadow-sm">
                                    <div class="w-full h-full overflow-hidden">
                                        <img :src="item.image" :alt="item.title"
                                            class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                    </div>
                                </div>
                                <h3
                                    class="text-xl font-serif font-medium group-hover:text-primary/70 transition-colors">
                                    {{ item.title }}
                                </h3>
                                <p class="text-sm text-muted-foreground">
                                    {{ item.category }}
                                </p>
                            </div>
                        </RouterLink>
                    </div>
                </div>
            </section>

            <!-- About Section -->
            <section class="py-24 bg-white border-t border-gray-200">
                <div class="container mx-auto px-4">
                    <div class="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
                        <div class="w-full lg:w-1/2 relative">
                            <img :src="shrutiImg" alt="Shruti - Artist"
                                class="rounded-lg shadow-xl w-full max-h-[420px] object-cover" />
                        </div>

                        <div class="w-full lg:w-1/2 space-y-6">
                            <div
                                class="inline-flex items-center gap-2 text-gray-500 text-sm font-medium uppercase tracking-widest">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 2L2 7v6c0 5 10 9 10 9s10-4 10-9V7L12 2z" />
                                </svg>
                                <span>The Artist</span>
                            </div>

                            <h2 class="text-4xl md:text-5xl font-serif text-gray-900">Meet Shruti</h2>

                            <p class="text-lg text-gray-700">
                                Hi, I’m Shruti – the heart, hands,
                                and eyes behind ArtPulse by
                                Shruti.
                                Art has always been more than
                                just a skill for me – it’s my way of
                                connecting, feeling, and telling
                                stories without words.
                            </p>
                            <p class="text-lg text-gray-700">
                                What started as a childhood passion slowly bloomed into a lifelong journey lled with
                                portraits, sketches, and colors that speak emotions. I specialize in realistic
                                sketching, expressive watercolor work, and storytelling through brush and ink. Whether
                                it’s a quiet moment captured in a sketch or the vibrant spirit of a festival, each piece
                                I create re ects a piece of my soul.
                            </p>

                            <div class="flex flex-wrap gap-4 pt-4">
                                <a href="https://www.youtube.com/@artpulse_by_shruti" target="_blank">
                                    <button
                                        class="flex items-center gap-2 bg-red-600 text-white rounded-full px-4 py-2">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M19.615 3.184a1 1 0 00-.872-.184L4 8v8l14.743 5.001a1 1 0 00.872-.184 1 1 0 00.308-.872V4.056a1 1 0 00-.308-.872z" />
                                        </svg>
                                        Subscribe on YouTube
                                    </button>
                                </a>

                                <a href="https://www.instagram.com/artpulse_by_shruti/" target="_blank">
                                    <button
                                        class="flex items-center gap-2 border border-gray-400 rounded-full px-4 py-2">
                                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                            <path
                                                d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zM12 7a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6zm4.5-3a1 1 0 110 2 1 1 0 010-2z" />
                                        </svg>
                                        Follow on Instagram
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Testimonials -->
            <section v-if="testimonials.length" class="py-24 bg-gray-50 border-t border-gray-200">
                <div class="container mx-auto px-4">
                    <div class="flex flex-col md:flex-row items-end justify-between mb-12 gap-4">
                        <div>
                            <h2 class="text-3xl md:text-4xl font-serif mb-2">Kind Words</h2>
                            <p class="text-gray-600">Stories shared by the ArtPulse community</p>
                        </div>

                        <RouterLink to="/testimonial">
                            <button class="text-blue-600 p-0 h-auto group text-lg font-serif flex items-center gap-1">
                                Share Your Story
                                <svg class="w-4 h-4 transition-transform group-hover:translate-x-1" fill="currentColor"
                                    viewBox="0 0 20 20">
                                    <path
                                        d="M12.293 3.293a1 1 0 011.414 1.414L10.414 8H17a1 1 0 110 2h-6.586l3.293 3.293a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414l5-5z" />
                                </svg>
                            </button>
                        </RouterLink>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <article v-for="testimonial in testimonials" :key="testimonial.id || testimonial.email || testimonial.name"
                            class="bg-white border border-gray-100 p-6 shadow-sm">
                            <div class="flex items-center justify-between mb-5">
                                <div
                                    class="w-12 h-12 bg-gray-100 flex items-center justify-center text-gray-400">
                                    <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                        <path
                                            d="M12 12c2.761 0 5-2.239 5-5s-2.239-5-5-5-5 2.239-5 5 2.239 5 5 5zm0 2c-3.314 0-8 1.686-8 5v1c0 1.105.895 2 2 2h12c1.105 0 2-.895 2-2v-1c0-3.314-4.686-5-8-5z" />
                                    </svg>
                                </div>
                                <div class="flex text-yellow-400 text-sm" aria-label="Rating">
                                    <span v-for="star in Number(testimonial.rating || 5)" :key="star">★</span>
                                </div>
                            </div>
                            <p class="text-gray-600 text-sm leading-relaxed italic mb-6">"{{ testimonial.message }}"</p>
                            <p class="text-sm font-bold text-gray-900">{{ testimonial.name }}</p>
                        </article>
                    </div>
                </div>
            </section>
        </main>

    </div>
</template>

<script>
import api from '@/services/api';
import ConstantPage from '@/components/utilities/ConstantPage.vue';
import { useTestimonialStore } from '@/store/testimonialStore';

export default {
    name: 'HomePage',
    mixins: [ConstantPage],
    data() {
        return {
            artworks: [],
            filter: 'All',
            imgLandscape: 'https://artpulsebyshruti.com/assets/IMG_2483_1765176100154-B6zvEOPi.JPG',
            imgKrishna: 'https://artpulsebyshruti.com/assets/WhatsApp_Image_2025-11-25_at_2.03.08_AM_(9)_1765176100149-DjQ3S6s3.jpeg',
            imgWomanYellow: 'https://artpulsebyshruti.com/assets/IMG_9037_1765176100153-CLgSQpEw.JPG',
            imgFlowerPink: 'https://artpulsebyshruti.com/assets/IMG_9049_1765176100154-Bzx5HcTF.JPG',
            imgAuthorBanner: 'https://artpulsebyshruti.com/assets/Screenshot_2025-12-08_124102_1765177899388-DXK5-S-D.png',
            shrutiImg: 'https://assets-allwebsites.s3.ap-south-1.amazonaws.com/artpulse/shruti.jpeg'
        }
    },
    mounted() {
        this.fetchProducts();
        this.fetchTestimonials();
    },
    computed: {
        filteredArtworks() {
            if (this.filter === 'All') {
                return this.artworks;
            }

            return this.artworks.filter(art =>
                art.categories?.some(cat => cat.name === this.filter)
            );
        },
        testimonials() {
            return useTestimonialStore().testimonials.slice(0, 3);
        }
    },
    methods: {
        async fetchProducts() {
            try {
                let param = {
                    onhomepage: 1,
                    fetchColumns: 'id,name,cp,sp,mrp,currency,width,height,measurement_unit,outofstock'
                }
                const response = await api.post('api/product/getwithcategories', param);

                const products = response.data?.data || [];

                // const categorySet = new Set();

                this.artworks = products.map(product => {
                    // collect categories
                    // product.product_category?.forEach(cat => {
                    //     if (cat.name !== 'Gallery') {
                    //         categorySet.add(cat.name);
                    //     }
                    // });

                    // let width = Number(product.width);
                    // let height = Number(product.height);
                    // let size = `${width} x ${height} ${capitalize(product.measurement_unit)}`;
                    // let status = product.outofstock === 0 ? 'available' : 'sold';

                    return {
                        id: product.id,
                        title: product.name,
                        // price: product.sp,
                        // size: size,
                        image: product.productmedia?.[0]?.small_fullurl,
                        // status: status,
                        // if product has multiple categories, use first for display
                        category: product.product_category?.[1]?.name ?? 'Uncategorized',
                        categories: product.product_category
                    };
                });

                // push unique categories
                // this.categories = ['All', ...Array.from(categorySet)];

            } catch (error) {
                console.error('Failed to fetch products:', error);
            }
        },
        fetchTestimonials() {
            useTestimonialStore().fetchTestimonials({
                companyid: this.COMPANY_ID
            });
        },
    }
}
</script>

<style scoped></style>
